<div class="max-w-xxl mx-auto mt-10 p-6 bg-white shadow rounded">
  <div class="max-w-md mx-auto">
    <h2 class="text-xl font-semibold mb-4">Refer Friends</h2>

    <div class="mb-4">
      <label class="block mb-1">Enter email addresses</label>
      <div class="flex flex-wrap gap-2 mb-2">
        <span *ngFor="let email of emailList" class="px-2 py-1 bg-blue-100 text-blue-700 rounded-full flex items-center">
          {{ email }}
          <button type="button" (click)="removeEmail(email)" class="ml-1 text-red-500">&times;</button>
        </span>
      </div>
      <input
        type="email"
        class="w-full border p-2 rounded"
        placeholder="Enter email and press Enter or comma"
        [formControl]="emailControl"
        (keydown)="handleKey($event)"
      />
      <p *ngIf="emailControl.invalid && emailControl.touched" class="text-red-500 text-sm mt-1">Invalid email format</p>
    </div>

    <button
      type="button"
      class="bg-indigo-600 text-white px-4 py-2 rounded hover:bg-indigo-700"
      (click)="onSubmit()"
      [disabled]="emailList.length === 0"
    >
      Submit Referrals
    </button>
    <button type="button"
    class="bg-fuchsia-700 ml-3 text-white px-4 py-2 rounded hover:bg-fuchsia-900" (click)="submitReferralWithoutToken()">
      Referral Without Token
    </button>

  </div>
  @if(emailList.length > 0 && captchaResponse) {
      <div class="mt-4">
        <h2 class="text-lg font-bold">Captcha Details</h2>
        <pre>{{ captchaResponse | json }}</pre>
      </div>
    }
    @if(captchaError) {
      <div class="mt-4">
        <pre class="text-red-500 text-sm">{{captchaError.error | json }}</pre>
      </div>
    }
</div>
